import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from 'src/app/modules/home/pages/home/home.component';
import { availableRoutes } from '@modules/home/routes.model';
import { AuthGuard } from '@app-core/guards/auth.guard';

export const usersModuleRoutes: Routes = [
  {
    path: '', component: HomeComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      // TODO: I don't know
      // {
      //   path: '', redirectTo: '/servers', pathMatch: 'full',
      // },
      ...availableRoutes
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(usersModuleRoutes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {
}
